Ext.define('SA.EditItemLabelFactory', {
    singleton: true,

    factories: {
        attribute: id => `<span>${SA.BadgedAttributeLabel.getHtml({attribute: id})}</span>`,
        business: id => SA.data.BusinessSearches.get(id).name,
        location: id => SA.EditLocationLabel.get(id)
    },

    forAttributes() {
        return this.getFactory('attribute', {html: true});
    },

    forBusinesses() {
        return this.getFactory('business', {html: false});
    },

    forLocations() {
        return this.getFactory('location', {html: true});
    },

    getFactory(name, {html}) {
        return {create: this.factories[name], isHtml: () => html};
    }
});